<template>
  <!-- 黑名单区域 -->
  <a-modal
    title="黑名单用户"
    :visible="blackVisible"
    width="800px"
    @cancel="HandleCancel"
  >
    <a-button @click="syncBlackUser" style="margin: 10px">黑名单同步</a-button>
    <a-table
      ref="table"
      size="middle"
      :rowKey="(record) => record.openid"
      :columns="columnBlack"
      :dataSource="blackUserList"
      :row-selection="{
        selectedRowKeys: blackDataListSelections,
        onChange: blackSelectChange,
      }"
      class="j-table-force-nowrap"
      :pagination="blackPagination"
      @change="blackHandleTableChange"
    >
      <template slot="headimgurlslot" slot-scope="text, record">
        <div class="anty-img-wrap">
          <a-avatar
            shape="square"
            :src="getHeadImageView(record.headimgurl)"
            icon="user"
          />
        </div>
      </template>
      <template slot="sexslot" slot-scope="text, record">
        <span v-if="record.sex === 1">男</span>
        <span v-if="record.sex === 2">女</span>
        <span v-if="record.sex === 0">未知</span>
      </template>
      <template slot="tagslot" slot-scope="text, record">
        <span>{{ getTagName(record.tagidList) }}</span>
      </template>
    </a-table>
    <template slot="footer">
      <a-button type="" @click="HandleCancel"> 取消 </a-button>
      <a-button
        type="primary"
        :disabled="this.blackDataListSelections.length <= 0"
        @click="blackHandleOk"
      >
        移出黑名单
      </a-button>
    </template>
  </a-modal>
  <!-- 黑名单区域END -->
</template>
<script>
import { getAction, postAction, getFileAccessHttpUrl } from '@/api/manage';
export default {
  data() {
    return {
      queryObj: {},
      blackGet: {},
      blackPagination: {
        current: 1,
        total: 0,
        pageSize: 10, //每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30'], //每页中显示的数据
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        }, //分页中显示总的数据
        showQuickJumper: true,
        showSizeChanger: true,
      },
      blackPageIndex: 1,
      blackPageSize: 10,

      blackVisible: false,
      blackDataListSelections: [],
      blackUserList: [],
      columnBlack: [
        {
          title: 'openId',
          dataIndex: 'openid',
          align: 'center',
          key: 'openid',
        },
        {
          title: '昵称',
          dataIndex: 'nickname',
          align: 'center',
          key: 'nickname',
        },
        {
          title: '头像',
          dataIndex: 'headimgurl',
          align: 'center',
          key: 'headimgurl',
          width: 120,
          scopedSlots: { customRender: 'headimgurlslot' },
        },
        {
          title: '性别',
          dataIndex: 'sex',
          align: 'center',
          key: 'sex',
          scopedSlots: { customRender: 'sexslot' },
        },
        {
          title: '地区',
          dataIndex: 'city',
          align: 'center',
          key: 'city',
        },
        {
          title: '标签',
          dataIndex: 'tagidList',
          align: 'center',
          key: 'tagidList',
          scopedSlots: { customRender: 'tagslot' },
        },
        {
          title: '关注时间',
          dataIndex: 'subscribeTime',
          align: 'center',
          key: 'subscribeTime',
        },
      ],
    };
  },
  methods: {
    //标签名称
    getTagName(tagidList) {
      let userTag = tagidList.split('[')[1].split(']')[0].split(',');
      let userTagContent = '';
      for (let i in userTag) {
        for (let j in this.tagListAll) {
          if (userTag[i] == this.tagListAll[j].id) {
            userTagContent += this.tagListAll[j].name + ',';
          }
        }
      }
      if (userTagContent.length > 0) {
        userTagContent = userTagContent.substr(0, userTagContent.length - 1);
      }
      return userTagContent;
    },
    getHeadImageView: function (headimgurl) {
      return getFileAccessHttpUrl(headimgurl);
    },
    blackHandleTableChange(pagination) {
      //const page = { ...this.userPagination };
      this.blackPagination.current = pagination.current;
      this.blackPagination.pageSize = pagination.pageSize;
      this.blackGet.pageNo = pagination.current;
      this.blackGet.pageSize = pagination.pageSize;
      this.blackPagination = pagination;
      this.add(this.blackGet);
    },
    HandleCancel() {
      this.blackVisible = false;
    },
    //黑名单选择
    blackSelectChange(selectedRowKeys) {
      this.blackDataListSelections = selectedRowKeys;
      console.log(this.blackDataListSelections);
    },

    //黑名单modal
    add(params) {
      this.blackGet = params;
      console.log(params);
      this.blackVisible = true;
      this.queryObj = params;
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/list', params).then(
        (res) => {
          if (res.success && res.code === 200) {
            this.blackUserList = res.result.records;
            this.blackPagination.total = res.result.total;
            //this.pagination.total = res.result.totalCount
          } else {
            this.blackUserList = [];
            //this.totalCount = 0
          }
          //this.dataListLoading = false
        }
      );
    },
    //同步黑名单粉丝
    syncBlackUser() {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/syncWxBlackUsers', {
        appId: this.queryObj.appId,
      }).then((res) => {
        if (res.success && res.code === 200) {
          this.$message.success('同步任务已经建立,请稍后刷新页面查看列表');
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //移出黑名单
    blackHandleOk(e) {
      postAction(process.env.VUE_APP_CMS_WECHAT + '/wxUser/pullBlack', {
        appid: this.queryObj.appId,
        openIds: this.blackDataListSelections.join(','),
      })
        .then((res) => {
          if (res.success && res.code === 200) {
            this.$message.success(res.message);
          } else {
            this.$message.error(res.message);
          }
          this.blackDataListSelections = [];
          this.blackVisible = false;
        })
        .finally(() => {
          this.$emit('ok');
        });
      // this.$emit('ok');
    },
  },
};
</script>
<style scoped lang="less">
/deep/ .ant-modal-body {
  height: 500px;
  overflow: auto;
}
</style>
